module.exports = __webpack_public_path__ + "img/2.9ab1a2e2.png";